import IconRender from 'components/common/IconRender'
import { Chat as ChatType } from 'components/types'
import { CustomColorsRef, IconSizes } from 'types/general'

interface ChatProps {
  selectedChat: ChatType | null
  handleSendMessage: () => void
  newMessage: string
  setNewMessage: (message: string) => void
}

const Chat = ({
  selectedChat,
  newMessage,
  handleSendMessage,
  setNewMessage,
}: ChatProps) => {
  return (
    <div className="w-full h-full max-h-fit flex flex-col pt-2 text-sm">
      {selectedChat ? (
        <div className="flex flex-col w-full h-full">
          <div className="flex items-center pb-1 pl-2 border-b border-gray-100 shadow-sm">
            <img
              src={selectedChat.avatar}
              alt={selectedChat.person}
              className="w-12 h-12 rounded-full mr-3"
            />
            <h2 className="text-lg font-semibold">{selectedChat.person}</h2>
          </div>
          <div className="flex-1 overflow-y-auto space-y-2 pr-2 pb-2 pt-2 max-h-full pl-2 scrollable-element">
            {selectedChat.messages.map(message => (
              <div
                key={message.id}
                className={`p-2 rounded-lg max-w-xs ${
                  message.sender === 'person1'
                    ? 'ml-auto bg-blue-100 text-blue-900 text-right'
                    : 'mr-auto bg-gray-100 text-gray-900 text-left'
                }`}
              >
                {message.text}
              </div>
            ))}
          </div>
          <div className="flex h-[40px] w-full pb-1 px-2">
            <input
              type="text"
              value={newMessage}
              onChange={e => setNewMessage(e.target.value)}
              placeholder="Type a message..."
              className="w-full rounded-l-lg h-[35px] bg-gray-100  focus:outline-none pl-2 focus:bg-blue-100"
            />
            <button
              onClick={handleSendMessage}
              className="h-[35px] p-1 px-4 bg-imovSecondary text-white rounded-r-lg"
            >
              <IconRender
                icon="regular-paper-plane"
                size={IconSizes.SM}
                color={CustomColorsRef.White}
              />
            </button>
          </div>
        </div>
      ) : (
        <div className="text-center text-gray-500">
          Select a chat to view messages
        </div>
      )}
    </div>
  )
}

export default Chat
